export function fetch() { return { type: 'PROPERTIES/FETCH', } }
export function fetch_one(id) { return { type: 'PROPERTY/FETCH', id } }
export function fetch_logs({ id, date }) { return { type: 'PROPERTY/LOGS/FETCH', id, date } }
export function clean() { return { type: 'PROPERTY/CLEAR' } }
export function fetch_guests(id, letter) { return { type: 'GUESTS/FETCH', id, letter } }
export function fetch_coorps(id, letter) { return { type: 'COORPS/FETCH', id, letter } }
export function search_guests(id, filters) { return { type: 'GUESTS/SEARCH', id, filters } }
export function search_coorps(id, filters) { return { type: 'COORPS/SEARCH', id, filters } }